export default {
  'collectPoint.title': '集點',
  'collectPoint.success': '集點成功',
  'collectPoint.obtained': '已獲得',
  'collectPoint.point': '點',
  'collectPoint.enter_amount': '請輸入交易金額',
  'collectPoint.enter_point': '請輸入點數數量',
  'collectPoint.next_step': '下一步',
  'collectPoint.warning.NOT_REACH_THRESHOLD': '未達集點門檻，僅新增交易紀錄',
  'collectPoint.error.LOYALTY_CARD_NOT_ENABLED': '集點活動未啟用',
  'collectPoint.error.LOYALTY_CARD_NOT_FOUND': '集點活動資訊錯誤',
  'collectPoint.error.SHOP_NOT_FOUND': '門市資訊錯誤',
  'collectPoint.error.FLEXIBLE_DEDUCTION_NOT_ENABLED': '該活動不允許扣點',
  'collectPoint.error.SEND_RULE_NOT_FLEXIBLE_SEND': '發送資訊錯誤',
  'collectPoint.error.NOT_ENOUGH_POINT_FOR_DEDUCT': '點數不足扣點',
  'collectPoint.error.PARTIAL_SEND_POINT_FAILED': '部分會員發點失敗',
  'collectPoint.error.PARTIAL_DEDUCT_POINT_FAILED': '部分會員扣點失敗',
  'collectPoint.error.LOYALTY_CARD_SHOP_ERROR': '門市不符合活動集點卡的限定門市',
  'collectPoint.error.ACCOUNT_SHOP_NOT_ELIGIBLE': '操作帳號所屬的門市不符合活動集點卡的限定門市',
  'collectPoint.error.VALIDATE_SEND_POINTS_LIMIT_IN_DAYS_FAILED': '超過每日集點限制',
  'collectPoint.error.AMOUNT_TO_MPS_CARD_POINT_FAILED': '發送失敗',
  'collectPoint.error.PARAMETERS_ERROR': '資訊錯誤',
  'collectPoint.error.MEMBER_PHONE_NOT_FOUND': '手機號碼不存在',
  'collectPoint.error.MEMBER_NOT_FULL': '非正式會員',
  'collectPoint.error.INTERNAL_SERVER_ERROR': '發生錯誤，請稍後再試一次',
} as Record<string, string>;
